import { toggleCollapse, onCollapseState, offCollapseState, requestCollapseState } from '../utils/collapse'

/* v-collapse-toggle="'id'" (boşlukla birden çok id): bootstrap-vue toggle direktifinin karşılığı.
   aria-controls, aria-expanded, collapsed / not-collapsed sınıfları ve overflow-anchor aynı;
   tıklama dinleyicisi bootstrap-vue'daki gibi bir kare sonra eklenir (SideBarStyle.vue'nun kendi
   dinleyicisi önce çalışır). Bootstrap JS kullanmaz. */

const STATE = '__estCollapseToggle';

function targetsOf(value) {
    const list = typeof value === 'string' ? value.split(/\s+/) : [].concat(value || []);
    return list.filter((target, index, all) => typeof target === 'string' && target && all.indexOf(target) === index);
}

function setToggleState(el, visible) {
    el.classList.toggle('not-collapsed', !!visible);
    el.classList.toggle('collapsed', !visible);
    el.setAttribute('aria-expanded', visible ? 'true' : 'false');
}

function isNonStandardTag(el) {
    return !['button', 'a'].includes(el.tagName.toLowerCase());
}

function addClickListener(el) {
    const state = el[STATE];
    if (state.clickHandler) el.removeEventListener('click', state.clickHandler);
    if (state.frame) window.cancelAnimationFrame(state.frame);
    state.frame = window.requestAnimationFrame(() => {
        state.frame = null;
        el.addEventListener('click', state.clickHandler);
    });
}

function update(el, binding) {
    const state = el[STATE];
    if (!state) return;

    if (isNonStandardTag(el)) {
        if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    }

    setToggleState(el, state.visible);

    const targets = targetsOf(binding.value);
    if (targets.length) {
        el.setAttribute('aria-controls', targets.join(' '));
        el.style.overflowAnchor = 'none';
    } else {
        el.removeAttribute('aria-controls');
        el.style.removeProperty('overflow-anchor');
    }

    addClickListener(el);

    if (targets.join(' ') !== state.targets.join(' ')) {
        state.targets = targets;
        targets.forEach(requestCollapseState);
    }
}

function bind(el, binding) {
    const state = {
        visible: false,
        targets: [],
        frame: null,
        clickHandler: () => {
            if (el.disabled) return;
            state.targets.forEach(toggleCollapse);
        },
        stateHandler: (id, visible) => {
            if (!state.targets.includes(id)) return;
            state.visible = visible;
            setToggleState(el, visible);
        }
    };
    el[STATE] = state;
    onCollapseState(state.stateHandler);
    update(el, binding);
}

function unbind(el) {
    const state = el[STATE];
    if (!state) return;
    offCollapseState(state.stateHandler);
    if (state.frame) window.cancelAnimationFrame(state.frame);
    el.removeEventListener('click', state.clickHandler);
    el.classList.remove('collapsed', 'not-collapsed');
    el.removeAttribute('aria-expanded');
    el.removeAttribute('aria-controls');
    el.style.removeProperty('overflow-anchor');
    delete el[STATE];
}

export default {
    beforeMount: bind,
    updated: update,
    unmounted: unbind
};
